import { useEffect, useState } from "react";
import { formatLaborDurationMinutes, resolveLaborDayMinutes } from "../../../../shared/laborDuration";
import { SHIFT_END_UNVERIFIED_NOTE_MARKER } from "../../../../shared/shiftDuration";

type LaborAssignment = {
  date?: string | Date | null;
  status?: string;
  totalMinutes?: number | null;
  activeStartTime?: Date | string | null;
  shiftDate?: string | Date | null;
  shiftStatus?: string | null;
  shiftTotalMinutes?: number | null;
  shiftActiveStartAt?: Date | string | null;
  startTime?: string | null;
  endTime?: string | null;
  notes?: string | null;
  shiftEndUnverified?: boolean;
};

/** Shows accumulated effective minutes without deriving duration from clock bounds. */
export function LaborDurationLabel({ assignment, className = "" }: {
  assignment: LaborAssignment;
  className?: string;
}) {
  const [now, setNow] = useState(() => new Date());
  const activeStart = assignment.activeStartTime instanceof Date
    ? assignment.activeStartTime
    : assignment.activeStartTime ? new Date(assignment.activeStartTime) : null;
  const hasRunningSegment = assignment.status === "working"
    && activeStart !== null
    && !Number.isNaN(activeStart.getTime());

  useEffect(() => {
    if (!hasRunningSegment) return;
    const timer = window.setInterval(() => setNow(new Date()), 15_000);
    return () => window.clearInterval(timer);
  }, [hasRunningSegment, assignment.activeStartTime]);

  const shiftEndUnverified = assignment.shiftEndUnverified === true
    || Boolean(assignment.notes?.includes(SHIFT_END_UNVERIFIED_NOTE_MARKER));
  const resolution = resolveLaborDayMinutes({ ...assignment, shiftEndUnverified }, now);
  if (resolution.planned) {
    return <span className={className}>Planificada · sin tiempo real</span>;
  }
  if (!resolution.durationVerified) {
    if (resolution.source === "equivalent_day") {
      return (
        <span className={className}>
          Equivalencia histórica no verificada (08:00–17:00) · {formatLaborDurationMinutes(resolution.equivalentMinutes)}, excluida del tiempo real
        </span>
      );
    }
    return (
      <span className={className}>
        Duración real no verificada
      </span>
    );
  }
  return <span className={className}>Tiempo efectivo real: {formatLaborDurationMinutes(resolution.minutes)}</span>;
}
